import client from './client';
import { axios as request } from './request';

export default {
  completeProfile: data => {
    return client.post('user/auth/complete-profile', data).then(res => res.data);
  },
  userActivate: data => {
    return client.post('user/auth/activate', data).then(res => res.data);
  },
  getPromotionProductCategories: () => {
    return request.get('publisher/product-categories');
  },
  getPromotionCountries: () => {
    return request.get('publisher/promotion-countries');
  },
  getPromotionCountriesSeller: () => {
    return request.get('seller/associate/publisher/promotion-countries');
  },
  getPromotionMethods: () => {
    return request.get('publisher/promotion-methods');
  },
  getUserProfile: () => {
    return request.get('publisher/profile');
  },
  updateProfile: data => {
    return request.put('publisher/profile', data);
  },
  updateTrackingTags: data => {
    return request.put('publisher/tracking-tags', data);
  },
  /**
   * 添加子账号
   * @param {*} data 
   * @returns 
   * @since 2025/05/21 22:04:09
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/createDelegateUserUsingPOST
   */
  addUser: (_, data) => {
    return request.post('user/delegation-accounts', data);
  },

  /**
   * 更新子账号
   * @param {*} data 
   * @returns 
   * @since 2025/05/28 20:25:31
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/updateDelegateUserUsingPOST
   */
  updateUser: (delegationId, data) => {
    return request.post(`user/delegation-accounts/${delegationId}`, data);
  },
  /**
   * 获取子账号列表
   * @returns 
   * @since 2025/05/21 22:19:44
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/listDelegateUsersUsingGET
   */
  getSubAccounts: () => {
    return request.get('user/delegation-accounts/delegates');
  },
  /**
   * 设置子账号状态(激活或禁用)
   * @param {*} delegationId 
   * @param {*} status active: 激活, deactive: 禁用
   * @returns 
   * @since 2025/05/21 22:39:10
   * 存彬 激活代理账号（子账号）mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/activateDelegateUserUsingPOST
   * 存彬 禁用代理账号（子账号）mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/deactivateDelegateUserUsingPOST
   */
  setUserStatus: (delegationId, status) => {
    return request.post(`user/delegation-accounts/${delegationId}/${status}`);
  },
  /**
   * 删除子账号
   * @param {*} userId 
   * @returns 
   * @since 2025/05/21 22:47:11
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/removeDelegateUserUsingDELETE
   */
  deleteUser: userId => {
    return request.delete(`user/delegation-accounts/${userId}`, { delegationId: userId });
  },
  /**
   * 子账号接受邀请
   * @param {*} data {password, confirmPassword, token}
   * @returns 
   * @since 2025/05/27 10:34:45
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/acceptDelegationInvitationUsingPOST
   */
  acceptInvitation: data => {
    return request.post('user/delegation-accounts/invitations/accept', data);
  },
  /**
   * 检查子账号是否是新用户
   * @param {*} token 
   * @returns 
   * @since 2025/05/27 10:49:05
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/preAcceptDelegationInvitationUsingGET
   */
  checkNewUser: token => {
    return request.get(`user/delegation-accounts/invitations/pre-accept?token=${token}`);
  },
  /**
   * 获取账号列表, 页面顶部switch account使用
   * @returns 
   * @since 2025/05/27 16:21:14
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/listDelegatorsUsingGET
   */
  getAccounts: () => {
    return request.get('user/delegation-accounts/delegators');
  },
  /**
   * 切换账号
   * @param {*} delegationId 
   * @returns 
   * @since 2025/05/27 17:00:48
   * 存彬 mock: http://118.31.23.117:8077/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/%E4%BB%A3%E7%90%86%E7%94%A8%E6%88%B7/switchToDelegatorUsingPOST
   */
  switchAccount: delegationId => {
    return request.post(`user/delegation-accounts/${delegationId}/switch`);
  }
}